import { useDispatch } from "react-redux";
import { allergies } from "./allergies";
import { setAllergies } from "../../../../entities/patient-stats/allergies/allergies.slice";

export const useGetAllergies = () => {
  const dispatch = useDispatch();

  const getAllergiesByPatientId = async (patientId: string) => {
    const res = await new Promise((resolve) => {
      setTimeout(() => {
        const filtered = allergies.filter(
          (p) => String(p.patientId) === patientId,
        );
        resolve(filtered[0]);
      }, 400);
    }); // имитация API

    dispatch(setAllergies(res)); // сохраняем в сторе
  };

  return {
    getAllergiesByPatientId,
  };
};
